module.exports = __webpack_public_path__ + "static/media/SelectImageset.0483aed7.png";